// @TODO: Remove once service updates these values
export const convertPreventiveCareTitle = (title: string) => {
  const lowerCaseTitle = title?.toLowerCase();
  if (lowerCaseTitle?.includes('hpv')) return 'HPV vaccine';
  if (lowerCaseTitle?.includes('diabetes')) return 'Diabetes follow-up';
  return title;
};
